module.exports = __webpack_public_path__ + "img/en_logo.b57c54ab.png";